import React from 'react';
import { useSelector } from 'react-redux';
import { Modal, Card, CardContent, CardHeader, IconButton } from '@mui/material';
import { plPL } from '@mui/x-data-grid';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { DataGridToolbar } from '../../../components/data-grid/DataGridToolbar';
import { BooleanColumn } from '../../../services/column-definitions';
import CloseIcon from '@mui/icons-material/Close';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)'
};

const OrdersModal = ({ open, handleClose, idList, setIdList, ordersDataForMessages }) => {
  const { module } = useSelector(state => state.app);

  const columns = [
    { field: 'identifier', headerName: 'Numer zamówienia', align: 'center', flex: 1 },
    { field: 'guardian_name', headerName: 'Opiekun', align: 'center', flex: 1 },
    { field: 'participant_name', headerName: 'Uczestnik', align: 'center', flex: 1 },
    { field: 'phone', headerName: 'Telefon', align: 'center', flex: 1 },
    { field: 'email', headerName: 'E-mail', align: 'center', flex: 1 },
    { field: 'camp', headerName: 'Turnus', align: 'center', flex: 1 },
    { field: 'return_agreement', headerName: 'Zwrot umowy', flex: 1, align: 'center', renderCell: params => <BooleanColumn {...params} /> },
    { field: 'qualification_card_returned', headerName: 'Wypełniono kartę', width: 160, align: 'center', renderCell: params => <BooleanColumn {...params} />, hide: false },
    { field: 'return_of_health_card', headerName: 'Zwrot karty zdrowia', width: 200, align: 'center', renderCell: params => <BooleanColumn {...params} />, hide: false },

    { field: 'event', headerName: 'Impreza', align: 'center', flex: 1 }
  ];

  const columns_zs = [
    { field: 'identifier', headerName: 'Numer zamówienia', align: 'center', flex: 1 },
    { field: 'office_representative_name', headerName: 'Imię osoby reprezentującej szkołę w kontaktach z biurem', align: 'center', flex: 1 },
    { field: 'office_representative_surname', headerName: 'Nazwisko osoby reprezentującej szkołę w kontaktach z biurem', align: 'center', flex: 1 },
    { field: 'office_representative_phone', headerName: 'Nr. telefonu osoby reprezentującej szkołę w kontaktach z biurem', align: 'center', flex: 1 },
    { field: 'office_representative_correspondence_email', headerName: 'E-mail osoby reprezentującej szkołę w kontaktach z biurem', align: 'center', flex: 1 }
  ];

  return (
    <Modal
      open={open}
      onClose={handleClose}
    >
      <Card sx={{ ...style, width: '75vw', height: '80vh', display: 'flex', flexDirection: 'column' }}>
        <CardHeader
          title="Lista zamówień do który zostanie wysłana wiadomość"
          action={
            <IconButton color="primary" onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          }
          sx={{ textAlign: 'center' }}
        />
        <CardContent sx={{ flexGrow: 1 }}>
          <DataGridPro
            rows={ordersDataForMessages}
            columns={module === 'zielone_szkoly' ? columns_zs : columns}
            disableColumnMenu={true}
            autoPageSize={false}
            rowsPerPageOptions={[10, 25, 50, 100]}
            pagination
            components={{
              Toolbar: DataGridToolbar
            }}
            checkboxSelection
            onSelectionModelChange={newSelectionModel => {
              setIdList(newSelectionModel);
            }}
            selectionModel={idList}
            localeText={plPL.components.MuiDataGrid.defaultProps.localeText}
          />
        </CardContent>
      </Card>
    </Modal>
  );
};

export default OrdersModal;
